export default __webpack_public_path__ + "static/sektionsritningar-ea607badbb650b53d9d858190592b127.pdf";